export default __webpack_public_path__ + "static/media/alert-close-icon.5a106d7a.svg";